import { render } from "./ComboboxAnchor.vue?vue&type=template&id=1988f6fe&ts=true"
import script from "./ComboboxAnchor.vue?vue&type=script&setup=true&lang=ts"
export * from "./ComboboxAnchor.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Shared/components/primitives/combobox/ComboboxAnchor.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1988f6fe"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1988f6fe', __exports__)) {
    api.reload('1988f6fe', __exports__)
  }
  
  module.hot.accept("./ComboboxAnchor.vue?vue&type=template&id=1988f6fe&ts=true", () => {
    api.rerender('1988f6fe', render)
  })

}


export default __exports__